<template>
  <base-modal :modal-id="'calculate-modal'" :is-modal-open="isOpen" @open-modal="onOpenModal" hide-header hide-footer @hide="onCloseModal">
    <template #modal-body>
      <div class="calculate-content-wrp">
        <div class="calculate-header">
          <div class="text-calculate-header">
            <span>{{ t('analytics.churn_rate') }}</span>
          </div>
          <div class="text-calculate-header-detail">
            <div>{{ t('analytics.churn_rate_detail_1') }}</div>
            <div>{{ t('analytics.churn_rate_detail_2') }}</div>
            <div>{{ t('analytics.churn_rate_detail_3') }}</div>
          </div>
          <div class="description-calculate-header">
            <span>{{ t('analytics.churn_rate_detail_4') }}</span>
            (<span @click="onOpenRecommendModal" class="description-calculate-more">{{ t('analytics.churn_rate_detail_5') }}</span
            >)
          </div>
        </div>

        <div class="cards">
          <div class="left-cards">
            <div :class="isSelectStandard ? 'card-active' : 'card'" @click.stop="onClickCardStandard">
              <div class="card-header-cal">
                <div><span>Standard Formula</span></div>
                <div
                  class="icon-expand"
                  :class="isExpandStandard ? 'icon-arrow icon-arrow-up' : 'icon-arrow icon-arrow-down'"
                  @click.stop="onClickCardExpandStandard"
                >
                  <ArrowDownIcon />
                </div>
              </div>
              <div class="card-body-cal">
                <p>{{ t('analytics.standard_formula_detail') }}</p>
                <div class="formula">
                  <img src="@assets/images/modules/analytics/Standard-Formula-Head.png" alt="Standard Head" />
                </div>
              </div>
            </div>
            <div v-if="isExpandStandard" class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/Standard-Formula.png" alt="Standard" />
            </div>
          </div>
          <div class="right-cards">
            <div :class="isSelectAdjusted ? 'card-active' : 'card'" @click.stop="onClickCardAdjusted">
              <div class="card-header-cal">
                <div><span>Adjusted Formula</span></div>
                <div
                  class="icon-expand"
                  :class="isExpandAdjusted ? 'icon-arrow icon-arrow-up' : 'icon-arrow icon-arrow-down'"
                  @click.stop="onClickCardExpandAdjusted"
                >
                  <ArrowDownIcon />
                </div>
              </div>
              <div class="card-body-cal">
                <p>{{ t('analytics.adjusted_formula_detail') }}</p>
                <div class="formula">
                  <img src="@assets/images/modules/analytics/Adjusted-Formula-Head.png" alt="Adjusted Head" />
                </div>
              </div>
            </div>
            <div v-if="isExpandAdjusted" class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/Adjusted-Formula.png" alt="Adjusted" />
            </div>
          </div>
        </div>

        <div class="actions">
          <button @click="onClickCancelButton" class="btn btn-outline-secondary d-flex align-items-center justify-content-center cancel-button">
            ยกเลิก
          </button>
          <button @click="onClickApplyButton" class="btn btn-primary d-flex align-items-center justify-content-center apply-button">นำไปใช้</button>
        </div>
      </div>
    </template>
  </base-modal>
  <recommend-modal :is-open="isRecommendModal" @close-modal="onCloseRecommendModal" />
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BaseModal from '@/views/components/modal/BaseModal.vue';
import SettingsIcon from '@/assets/icons/modules/analytics/churn-rate/SettingsIcon.vue';
import ArrowDownIcon from '@/assets/icons/base/navbarIcon/ArrowDownIcon.vue';
import RecommendModal from './RecommendModal.vue';
import { getCurrentInstance, Ref, ref } from 'vue';

interface Props {
  isStandard: boolean;
  isOpen: boolean;
  loading: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});
defineEmits(['close-modal', 'apply-modal']);

const { t } = useI18n();

const isRecommendModal: Ref<boolean> = ref(false);
const isSelectStandard: Ref<boolean> = ref(false);
const isSelectAdjusted: Ref<boolean> = ref(false);

const isExpandStandard: Ref<boolean> = ref(false);
const isExpandAdjusted: Ref<boolean> = ref(false);

const vm = getCurrentInstance()?.proxy;

function onClickCardExpandStandard() {
  isExpandStandard.value = !isExpandStandard.value;
}

function onOpenRecommendModal() {
  isRecommendModal.value = true;
}

function onCloseRecommendModal() {
  isRecommendModal.value = false;
}

function onClickCardStandard() {
  if (isSelectAdjusted.value) {
    if (!isSelectStandard.value) {
      isSelectStandard.value = true;
      isSelectAdjusted.value = false;
    } else {
      isSelectStandard.value = !isSelectStandard.value;
    }
  } else {
    isSelectStandard.value = !isSelectStandard.value;
  }
}

function onClickCardExpandAdjusted() {
  isExpandAdjusted.value = !isExpandAdjusted.value;
}

function onClickCardAdjusted() {
  if (isSelectStandard.value) {
    if (!isSelectAdjusted.value) {
      isSelectAdjusted.value = true;
      isSelectStandard.value = false;
    } else {
      isSelectAdjusted.value = !isSelectAdjusted.value;
    }
  } else {
    isSelectAdjusted.value = !isSelectAdjusted.value;
  }
}

function onClickCancelButton() {
  vm?.$emit('close-modal');
}

function onClickApplyButton() {
  vm?.$emit('apply-modal', isSelectStandard.value);
}
const onOpenModal = () => {
  if (props.isStandard) {
    isSelectAdjusted.value = false;
    isSelectStandard.value = true;
  } else {
    isSelectAdjusted.value = true;
    isSelectStandard.value = false;
  }
};
const onCloseModal = () => {
  vm?.$emit('close-modal');
};
</script>

<style lang="scss" scoped>
.icon-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}
.icon-arrow-up {
  transform: rotate(-270deg);
}
.icon-arrow-down {
  transform: rotate(-90deg);
}
:deep(.modal-inner) {
  width: 78rem !important;
  max-width: 78rem !important;
  max-height: 91vh !important;
}
.calculate-content-wrp {
  width: 100%;
  .calculate-header {
    text-align: center;
    margin-bottom: 20px;
    .text-calculate-header {
      font-family: Prompt;
      font-size: 22px;
      font-weight: 400;
      line-height: 37.8px;
      text-align: left;
      color: #000000;
      span {
        margin-left: 20px;
      }
    }
    .text-calculate-header-detail {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      margin-bottom: 20px;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #606a6c;
    }
    .description-calculate-header {
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #606a6c;
      margin-left: 20px;
      margin-bottom: 10px;
      .description-calculate-more {
        color: #007fff;
        cursor: pointer;
      }
    }
  }
  .cards {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-left: 1rem;
    margin-right: 1rem;

    .card {
      border: 1px solid #b4b4b4;
      border-radius: 25px;
      height: 330px;
      width: 35rem;
      padding: 1.563rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      .card-header-cal {
        display: flex;
        justify-content: space-between;
        span {
          font-family: Prompt;
          font-size: 20px;
          font-weight: 400;
          line-height: 30.24px;
          text-align: left;
        }
        .icon-expand {
          fill: #2d2d2d;
        }
      }

      .card-body-cal {
        p {
          font-family: Prompt;
          font-size: 14px;
          font-weight: 300;
          line-height: 21.17px;
          text-align: left;

          color: #606a6c;
        }
        .formula {
          border-radius: 20px;
          .formula-title {
            font-family: Prompt;
            font-size: 18px;
            font-style: italic;
            font-weight: 400;
            line-height: 22.68px;
            text-align: left;
            color: #5180ae;
          }
        }
      }
    }

    .card-active {
      border: 6px solid #007fff;
      border-radius: 25px;
      width: 35rem;
      height: 330px;
      padding: 1.563rem;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
      background-color: #f9fbff;
      cursor: pointer;
      .card-header-cal {
        display: flex;
        justify-content: space-between;
        span {
          font-family: Prompt;
          font-size: 20px;
          font-weight: 400;
          line-height: 30.24px;
          text-align: left;
        }
        .icon-expand {
          fill: #007fff;
        }
      }

      .card-body-cal {
        p {
          font-family: Prompt;
          font-size: 14px;
          font-weight: 300;
          line-height: 21.17px;
          text-align: left;

          color: #606a6c;
        }
        .formula {
          border-radius: 20px;
          .formula-title {
            font-family: Prompt;
            font-size: 18px;
            font-style: italic;
            font-weight: 400;
            line-height: 22.68px;
            text-align: left;
            color: #5180ae;
          }
        }
      }
    }
    .formula-detail {
      margin-top: 1rem;
      width: 35rem;
    }
  }

  .actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 3.125rem;
    .cancel-button {
      cursor: pointer;
      min-width: 6.25rem;
    }
    .apply-button {
      cursor: pointer;
      min-width: 6.25rem;
    }
  }
}
</style>
